import * as type from "../types";

const initialState = {
  list: [],
  loading: false,
  error: false,
};

export default function productionDatas(state = initialState, action) {
  switch (action.type) {
    case type.GET_PRODUCTION_DATA_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_PRODUCTION_DATA_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_PRODUCTION_DATA_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
